import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { PageView } from 'components/Tracking';
import './styles.css';

const AccountPageLayout = props => {
  const {
    pageClass,
    headerContent,
    mainContent,
    sidebarContent,
    fullWidthContent,
    pageTitle,
    children,
    location,
  } = props;

  const baseClass = pageClass ? ' ' + pageClass : '';
  const contentClass = pageClass ? ` ${pageClass}__content` : ``;
  const panelsClass = pageClass ? ` ${pageClass}__panels` : ``;
  const sidebarClass = pageClass ? ` ${pageClass}__sidebar` : ``;

  useEffect(() => {
    PageView();
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      {pageTitle && (
        <Helmet>
          <title>{pageTitle}</title>
        </Helmet>
      )}

      <section className={'account_page' + baseClass}>
        {headerContent && headerContent}
        <div className="container">
          <div className={'account_page__content' + contentClass}>
            {sidebarContent && (
              <div className={'account_page__sidebar' + sidebarClass}>
                {sidebarContent}
              </div>
            )}
            <div
              className={
                sidebarContent
                  ? 'account_page__panels' + panelsClass
                  : 'account_page__panels--fullwidth' + panelsClass
              }
            >
              {mainContent}
            </div>
          </div>
          {children}
        </div>
        {fullWidthContent && (
          <div className="account_page__fullwidth-content">{fullWidthContent}</div>
        )}
      </section>
    </>
  );
};

export default withRouter(AccountPageLayout);
